/**
 * Default breakpoints for story responsive layout.
 */
export const DEFAULT_STORY_SMALL_SCREEN_WIDTH = 450.98;
export const DEFAULT_STORY_SMALL_SCREEN_HEIGHT = 450.98;
export const DEFAULT_STORY_MEDIUM_SCREEN_WIDTH = 767.98;
export const DEFAULT_STORY_MEDIUM_SCREEN_HEIGHT = 550.98;
